import CimsQuickLinkEntityTable from 'components/CIMSTable/common/components/CimsQuickLinkEntityTable'
import {
  useCreateCasQuickLinkMutation,
  useEditCasQuickLinkMutation,
  useGetCasQuickLinksQuery,
  useRestoreCasQuickLinkMutation,
  useSoftRemoveCasQuickLinkMutation,
} from 'schema'
import { Permission } from '@cims-online/shared'

const CASQuickLinks: React.FC = () => (
  <CimsQuickLinkEntityTable
    entity="Submittal"
    query={useGetCasQuickLinksQuery}
    getQuickLinks={(data) => data?.casQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateCASQuickLink,
      mutation: useCreateCasQuickLinkMutation,
      getLabel: ({ createCASQuickLink: create }) => create.casQuickLink,
    }}
    edit={{
      permission: Permission.EditCASQuickLink,
      mutation: useEditCasQuickLinkMutation,
      getLabel: ({ editCASQuickLink: edit }) => edit.casQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreCASQuickLink,
      mutation: useSoftRemoveCasQuickLinkMutation,
      getLabel: ({ softRemoveCASQuickLink: remove }) => remove.casQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreCASQuickLink,
      mutation: useRestoreCasQuickLinkMutation,
      getLabel: ({ restoreCASQuickLink: restore }) => restore.casQuickLink,
    }}
  />
)

export default CASQuickLinks
